import { render, staticRenderFns } from "./vs-form-datetime.vue?vue&type=template&id=c1dcc23c"
import script from "./vs-form-datetime.vue?vue&type=script&lang=js"
export * from "./vs-form-datetime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports